module.exports = __webpack_public_path__ + "img/product_flow.af5dc61b.png";